export default __webpack_public_path__ + "static/Marion-1601565ed5ac06db84e4c855c34fa0ec.webp";